export const DEFAULT_SESSION_FEATURE_TOGGLES = {
  showVideoTab: true,
  showLiveCodeTab: true,
  showInteractiveTab: true,
  enableLearningCards: true,
  enableQuickQuiz: true,
  enableQuickExercises: true,
  enableMatching: true,
  enableSyntaxGuess: true,
  enableCodePlayground: true,
  enablePresentationDeck: true
};

export const SESSION_FEATURE_GROUPS = [
  {
    label: 'Classroom Access Tabs',
    description: 'Control which classroom tabs appear for students inside the live experience.',
    keys: [
      { key: 'showVideoTab', label: 'Video Classroom' },
      { key: 'showLiveCodeTab', label: 'Live Code Lab' },
      { key: 'showInteractiveTab', label: 'Interactive Arcade' }
    ]
  },
  {
    label: 'Interactive Activities',
    description: 'Enable or disable specific interactive modules within the interactive classroom.',
    keys: [
      { key: 'enableLearningCards', label: 'Learning Cards' },
      { key: 'enableQuickQuiz', label: 'Quick Quiz' },
      { key: 'enableQuickExercises', label: 'Quick Exercises' },
      { key: 'enableMatching', label: 'Matching' },
      { key: 'enableSyntaxGuess', label: 'Syntax Guess' },
      { key: 'enableCodePlayground', label: 'Code Playground' },
      { key: 'enablePresentationDeck', label: 'Presentation Deck' }
    ]
  }
];

export const mergeSessionFeatureToggles = (overrides = {}) => ({
  ...DEFAULT_SESSION_FEATURE_TOGGLES,
  ...overrides
});
